export enum OccurrenceEnvironmentalType {
  WAVE = "wave",
  WIND = "wind",
  RAIN = "rain",
  WATER_LEVEL = "water_level",
  FOG = "fog",
  TEMPERATURE = "temperature",
  CURRENT = "current",
}
